import { render, staticRenderFns } from "./ShopContacts.vue?vue&type=template&id=555ef0bc&scoped=true&"
import script from "./ShopContacts.vue?vue&type=script&lang=js&"
export * from "./ShopContacts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "555ef0bc",
  null
  
)

export default component.exports